// /src/utils/filename.ts

/** Доп. опции формирования имени файла */
export type DefaultFilenameOpts = {
  /** Добавить время: _HH-mm (локальное) */
  withTime?: boolean;
  /** Разделитель между Y, M, D (по умолчанию "-") */
  sep?: string;
};

/**
 * Возвращает имя в виде: `${prefix}_YYYY{sep}MM{sep}DD[_HH-mm?]`
 * Локальная дата (без UTC-сюрпризов).
 */
export function defaultFilename(
  prefix: string,
  date: Date = new Date(),
  opts: DefaultFilenameOpts = {}
): string {
  const sep = opts.sep ?? '-';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');

  let s = `${prefix}_${y}${sep}${m}${sep}${d}`;

  if (opts.withTime) {
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    s += `_${hh}-${mm}`;
  }
  return s;
}
